import React from "react";

import ReactEcharts from "echarts-for-react";

function SimpleAreaChart({ data }) {
  const style = {
    height: "99%",
    width: "99%",
  };
  const option = {
    color: ["#BBE0F7"],
    dataset: {
      source: data,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          backgroundColor: "#6a7985",
        },
      },
      formatter: (params) => {
        let meses = [
          0,
          "Jan ",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ];

        const prof_percent = params[0].value.porcent_confirmada_prof;
        return (
          "<strong>" +
          meses[parseInt(params[0].value.mes.split("/")[0])] +
          " de " +
          params[0].value.ano +
          "</strong>" +
          '<br /> Porcentagem: <strong style="float:right;marginLeft:20px">' +
          prof_percent +
          "%</strong>"
        );
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      top: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: true,
      axisLabel: {
        fontSize: 10,
        fontWeight: 600,
      },
    },

    yAxis: [
      {
        type: "value",
        splitLine: {
          show: true,
        },
        axisLabel: {
          fontSize: 10,
          fontWeight: 600,
          formatter: function (val) {
            return val + "%";
          },
        },
        axisPointer: {
          label: {
            formatter: function (params) {
              return params.value.toFixed(2) + "%";
            },
          },
        },
      },
    ],

    series: [
      {
        name: "% de casos",
        type: "line",
        stack: "总量",
        smooth: false,
        showSymbol: false,
        encode: {
          y: "porcent_confirmada_prof",
        },
        areaStyle: {
          color: "#BBE0F7",
          opacity: 1,
        },
        lineStyle: {
          width: 0,
        },
      },
    ],
  };
  return <ReactEcharts option={option} style={style} />;
}

export default SimpleAreaChart;